import Lottie from 'lottie-react-web';
import * as S from "./styled";

type PropsLottie = {
	animationData: any;
	width: number;
	height: number;
	bg?: any;
	title?: string;
	onAnimationFinish?: (isCancelled: boolean) => void;
	duration?: any;
	loop?: any;
};

export function Loading({
	animationData,
	width,
	height,
	bg,
	title,
}: PropsLottie) {
	return (
		<S.Container style={{ backgroundColor: bg }}>
			<S.SubContainer style={{ width: width, height: height }}>
				<Lottie
					options={{
						animationData: animationData,
						loop: true,
						autoplay: true,
					}}
					style={{ width: '100%', height: '100%' }}
				/>
			</S.SubContainer>
			<S.Title>
				{title}
			</S.Title>
		</S.Container>
	);
}
